import { Spritesheet, Texture, TextureSource } from 'pixi.js';
import { ISpritesheetMetadata } from '../data/spritesheets/generated/sprite-metadata';

/**
 * Builds and parses one Spritesheet per entry, keyed by entry name. Shared by
 * the boot loader and the on-demand bundle loader (replaces the inline loop in
 * useSpritesLoader).
 */
export async function buildSpritesheets(
  entries: ISpritesheetMetadata[],
): Promise<{ [name: string]: Spritesheet }> {
  const out: { [name: string]: Spritesheet } = {};
  for (const entry of entries) {
    const sheet = new Spritesheet(
      Texture.from(entry.metadata.meta.image as TextureSource),
      entry.metadata,
    );
    await sheet.parse();
    out[entry.name] = sheet;
  }
  return out;
}
